import {translations} from 'presentation/translations-new';
import {FlowEnum} from '../../booking/constants';

const {bookOdonto, authorizations} = translations['pt-br'].privateFlow.services;
const {selectUf} = translations['pt-br'].commons;

const getUfSelectionHeaderTitle = (flowType: FlowEnum) => {
	if (flowType === FlowEnum.ODONTO) return bookOdonto;
	if (flowType === FlowEnum.AUTHORIZATIONS) return authorizations;

	return selectUf;
};

export {getUfSelectionHeaderTitle};
